module.exports = __webpack_public_path__ + "img/bg-qiu.9971f15a.png";